import { render, staticRenderFns } from "./attachment_list.vue?vue&type=template&id=e805c4de"
import script from "./attachment_list.vue?vue&type=script&lang=js"
export * from "./attachment_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports